<template>
  <px-custom-dialog v-model="dialog" content-class="rounded-card" width="1280">
    <template v-slot:activator="{ on }">
      <v-btn icon
             v-on="on">
        <v-icon>mdi-eye</v-icon>
      </v-btn>
    </template>
    <template v-slot:title>
      Solicitação
      <v-btn class="ml-3" icon link target="_blank" :to="linkSolicitacao">
        <v-icon>mdi-open-in-new</v-icon>
      </v-btn>
    </template>
    <template>
      <px-requisicao-detalhes is-modal-view
                              :requisicao-id-prop="requisicaoId"/>
    </template>
  </px-custom-dialog>
</template>

<script>
import RequisicaoDetalhes from '@/modules/requisicao/detalhes/RequisicaoDetalhes.vue';

export default {
  props: {
    requisicaoId: {
      type: [String, Number],
    },
  },
  data() {
    return {
      dialog: false,
    };
  },
  computed: {
    linkSolicitacao() {
      return `/requisicao/${this.requisicaoId}`;
    },
  },
  components: {
    pxRequisicaoDetalhes: RequisicaoDetalhes,
  },
};
</script>
